import store from '@/helpers/store'
import api from '@/helpers/api'
import axios from '@/helpers/axios'
import Vue from 'vue'
/*import VueToast from 'vue-toast-notification';*/
import 'vue-toast-notification/dist/theme-sugar.css';
import _ from "lodash";
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
/*Vue.use(VueToast);*/
export default (to, from, next) => {

    if (store.getters['auth/authenticated']) {
        store.dispatch('pageLoading/setLoading', true)
        if(store.getters['m3Sketch/companies'].length < 1) {
            axios.get(api.API_ENDPOINTS.m3company)
                .then(response => {
                    store.dispatch('m3Sketch/setCompanies', response.data)
                    axios.get(api.API_ENDPOINTS.m3Licenses)
                        .then(response => {
                            store.dispatch('m3Sketch/setLicenses', response.data)
                            middlewareCheck()
                        })
                })
        } else {
            middlewareCheck()
        }
    } else {
        next({ name: 'Login' })
    }

    function middlewareCheck() {
        if (store.getters['m3Sketch/companies'] && store.getters['m3Sketch/companies'].length === 0) {
            Vue.$toast.error('Nu există companii adăugate pe acest cont.')
            store.dispatch('pageLoading/setLoading', false)
            next({ name: 'M3Status' })
        } else {
            let company = store.getters['m3Sketch/companies'][0];
            if(!JSON.parse(localStorage.getItem('currentM3Company')) || !JSON.parse(localStorage.getItem('currentM3Company')).id){
                localStorage.setItem('currentM3Company', JSON.stringify(company))
            }
            let licensesNumber = Number(store.getters['m3Sketch/licenses'] ? store.getters['m3Sketch/licenses'].m3_licenses_available : 0) + Number(store.getters['m3Sketch/licenses'] ? store.getters['m3Sketch/licenses'].m3_licenses_used : 0)

            if(store.getters['auth/impersonated'] === null){
                axios.get(api.API_ENDPOINTS.checkImpersonate)
                    .then(response => {
                        store.dispatch('auth/setImpersonated', !!response.data);
                        if(store.getters['auth/impersonated']){
                            checkLicenses(1);
                        }
                        else{
                            checkLicenses(licensesNumber);
                        }
                    })
            }
            else{
                if(store.getters['auth/impersonated']){
                    checkLicenses(1);
                }
                else{
                    checkLicenses(licensesNumber);
                }
            }

        }
    }

    function checkLicenses(licensesNumber){
        if(licensesNumber === 0) {
            let currentCompany = _.filter(store.getters['m3Sketch/companies'], v => Number(v.business_id) === Number(JSON.parse(localStorage.getItem('currentM3Company')).business_id))
            let today = new Date(store.getters['m3Sketch/licenses'].today);
            let expire = new Date(currentCompany[0] ? currentCompany[0].created : new Date());
            if(expire < new Date('02-21-2022')) {
                expire = new Date('02-28-2022')
            } else {
                expire.setDate(expire.getDate() + 7);
            }

            if(expire <  new Date('02-28-2022'))
                expire =  new Date('02-28-2022')

            let diffTime =  expire - today;
            // let difference = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if(Number(diffTime) < 0) {
                store.dispatch('pageLoading/setLoading', false)
                next({ name: 'Neautorizat' })
            } else {
                next()
            }
        } else {
            next()
        }
    }

}
